import { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  apiUrls,
  billingBlockedStatuses,
  dataStorageKeywords,
  routeURL,
} from 'src/utils/properties.utils';
import { getEncryptedLocalStorageData } from 'src/utils/dataStorageManagement.utils';
import { axiosTokenInstance } from 'src/utils/axiosInstance.utils';

interface LoginCheckProps {
  element: JSX.Element;
}

export const LoginCheck: FC<LoginCheckProps> = ({ element }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const verifyLogin = async () => {
      const isLoggedIn = await getEncryptedLocalStorageData(
        dataStorageKeywords.IS_LOGGED_IN
      );

      if (!isLoggedIn) {
        navigate(routeURL.LOGIN);
        return;
      }

      try {
        const { data } = await axiosTokenInstance.get(
          apiUrls.SUBSCRIPTION_STATUS
        );
        const status = data?.data?.status;
        const settingsPath = routeURL.USER + routeURL.SETTINGS;

        if (
          billingBlockedStatuses.includes(status) &&
          location.pathname !== settingsPath
        ) {
          navigate(settingsPath, {
            replace: true,
            state: { billingRequired: true, subscriptionStatus: status },
          });
          return;
        }
      } catch {
        // Let the backend response on the target page handle unusual failures.
      }

      setLoading(false);
    };

    verifyLogin();
  }, [location.pathname, navigate]);

  if (loading) {
    return null;
  }

  return element;
};
